import React, { FC } from 'react';
import { StepModel } from '../../../../models/form/step';
import FormSectionMultiple from './section/FormSectionMultiple';
import FormSection from './section/FormSection';
import { noop } from '../../../../utilities/FunctionUtilities';
import { useIntl } from 'react-intl';
import { getText } from '../../../../utilities/CultureUtilities';

interface Props {
  step: StepModel;
  fieldProperties?: any;
  readOnlyMode?: boolean;
  addSection?: (id: string) => void;
  removeSection?: (id: string) => void;
}

const FormStep: FC<Props> = ({
  step,
  fieldProperties,
  readOnlyMode,
  addSection = noop,
  removeSection = noop,
}: Props) => {
  const intl = useIntl();

  return (
    <React.Fragment>
      {step.sections.map((section, sectionIndex) => {
        if (section.multiple) {
          return (
            <div className="section" key={`section-${sectionIndex}`}>
              <div className="section-name">
                <span>{getText(section.name, intl.locale)}</span>
              </div>
              <FormSectionMultiple
                fieldProperties={fieldProperties}
                addSection={addSection}
                removeSection={removeSection}
                readOnlyMode={readOnlyMode}
                section={section}
                key={`section-${sectionIndex}`}
              />
            </div>
          );
        }
        return (
          <div className="section" key={`section-${sectionIndex}`}>
            <div className="section-name">
              <span>{getText(section.name, intl.locale)}</span>
            </div>
            <FormSection
              fieldProperties={fieldProperties}
              readOnlyMode={readOnlyMode}
              section={section}
              key={`section-${sectionIndex}`}
            />
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default FormStep;
